export default function prepareQueryString(props: { [key: string]: any }) {
  const queryString = new URLSearchParams();

  Object.entries(props).forEach(([key, value]) => {
    if (value) queryString.append(key, value);
  });

  return queryString.toString();
}
